export const convertDoctors = doctors =>
  doctors.map(doctor => ({
    ...doctor,
    fullNameEmail: doctor.blocked
      ? `【募集制限中】${doctor.fullName} (${doctor.email})`
      : `${doctor.fullName} (${doctor.email})`,
  }))
